export default (theme, params, classes) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        flex: '1 1 auto',
        minWidth: 0,
    },
    // Collapsed rail: hide everything but the mark, same as the nav rows drop
    // their label and caret.
    collapsed: {
        [`& .${classes.triggerText}`]: {
            display: 'none',
        },
        [`& .${classes.triggerChevron}`]: {
            display: 'none',
        },
    },
    // Mirrors the nav row geometry so the mark lands on the same icon centerline
    // and the card grows identically as the rail expands.
    trigger: {
        display: 'flex',
        alignItems: 'center',
        flex: '1 1 auto',
        minWidth: 0,
        width: 'auto',
        height: 40,
        justifyContent: 'flex-start',
        textTransform: 'none',
        gap: theme.spacing(1.5),
        margin: theme.spacing(0.25, 1),
        paddingLeft: theme.spacing(1.75),
        paddingRight: theme.spacing(1.5),
        borderRadius: theme.spacing(1),
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.secondary.hover,
        },
    },
    triggerLogo: {
        // 21px to match the wordmark's O and the single-org mark exactly, so the
        // Osano O is the same size with or without multiple customers.
        width: 21,
        height: 21,
        flexShrink: 0,
        '& .logo': {
            fill: theme.palette.common.white,
        },
    },
    triggerText: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: '1 1 auto',
        minWidth: 0,
    },
    triggerBrand: {
        fontSize: '0.6875rem',
        lineHeight: 1.2,
        color: theme.palette.grey[400],
    },
    triggerLabel: {
        maxWidth: '100%',
        fontWeight: 700,
        fontSize: '0.875rem',
        lineHeight: 1.3,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    triggerChevron: {
        flexShrink: 0,
        color: theme.palette.common.white,
    },
    menuList: {
        minWidth: 240,
        maxWidth: 360,
        maxHeight: 360,
        overflowY: 'auto',
    },
    menuItem: {
        whiteSpace: 'normal',
    },
});
